import { Constants } from '@leverege/api-redux';
import { UI } from '@leverege/ui-redux';
export default class ImagineDeviceApi {
  constructor({
    relationship
  }) {
    this.relationship = relationship;
    this.molten = window.leveregeMolten.molten;
    this.projectId = this.molten.getConfig('api/projectId');
  }
  getSystemOrDevice(imagineSystemOrDeviceId) {
    return async (dispatch, getState, {
      api
    }) => {
      const systemId = this.relationship?.systemId || this.relationship?.options?.systemId;
      const blueprints = getState()?.blueprints?.[this.projectId]?.blueprints;
      if (!blueprints) {
        return null;
      }
      if (systemId === imagineSystemOrDeviceId) {
        return null;
      }
      if (!imagineSystemOrDeviceId) {
        return null;
      }
      const isLoading = getState()?.ui?.fota?.[imagineSystemOrDeviceId]?.isLoading;
      const isError = getState()?.ui?.fota?.[imagineSystemOrDeviceId]?.isError;
      if (isLoading || isError) {
        return null;
      }

      // assume device id
      try {
        dispatch(UI.set(`fota/${imagineSystemOrDeviceId}/isLoading`, true));
        const data = await api.system(systemId).devices().get(imagineSystemOrDeviceId);
        const blueprintAlias = blueprints.find(bp => bp.id === data?.blueprintId)?.alias;
        if (blueprintAlias) {
          dispatch({
            type: Constants.INTERFACE_GET,
            path: `${systemId}/${blueprintAlias}/${imagineSystemOrDeviceId}`,
            data
          });
        }
        dispatch(UI.set(`fota/${imagineSystemOrDeviceId}/isLoading`, false));
        return data;
      } catch (err) {
        dispatch(UI.set(`fota/${imagineSystemOrDeviceId}/isError`, true));
        // I guess it wasn't a device id
      }
      return null;
    };
  }
}